<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>系统设置</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas datass" >
					<div class="selectdata" v-if="$store.state.user.userinfo.flag==1">
						<div class="titles">修改logo</div>
						<el-upload 
							:data="{token:$store.state.user.userinfo.token}"
							:action="$uploadImg"
							style="margin-bottom:20px"
							:show-file-list="false"
							:on-success="success"
							:before-upload="$limitImg">
							<div class="logos">
								<img :src="imgLogo" alt="">
							</div>
						</el-upload>
						<el-button type="primary" @click="setlogo">立即修改</el-button>
					</div>
					<div class="selectdata" style="border-right:none">
						<div class="titles">修改密码</div>
						<el-form style="width: 350px" ref="formData" :model="formData" label-width="100px" :rules="rules">
							<el-form-item class="form_item" label="原密码" prop="oldpword">
								<el-input placeholder="请输入原密码" v-model="formData.oldpword"></el-input>
							</el-form-item>
							<el-form-item class="form_item" label="新密码" prop="password">
								<el-input placeholder="请输入新密码" v-model="formData.password"></el-input>
							</el-form-item>
							<el-form-item class="form_item" label="确认新密码"  prop="newPwd">
								<el-input placeholder="请再次输入新密码" v-model="formData.newPwd"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit">立即修改</el-button>
								<el-button @click="resetForm">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { xtsz } from '@/axios'
	import { mapState } from "vuex"
	let that;
	export default{
		data(){
			var checkPwd = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.formData.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return{
				formData:{
					oldpword: '',
					password: '',
					flag:this.$store.state.user.userinfo.flag,
					user_id:this.$store.state.user.userinfo.id,
					newPwd:""
				},
				imgLogo:'',
				rules:{
					oldpword:[{ required: true, message: '请输入原密码', trigger: 'blur' }],
					password:[{ required: true, message: '请输入新密码', trigger: 'blur' }],
					newPwd:[{ required: true, validator: checkPwd, trigger: 'blur' }],
				}
			}
		},
		computed:{
			...mapState({
				logos:state => state.user.logo,
				dwid:state => state.user.userinfo.id,
			})
		},
		methods:{
			onSubmit(){
				that.$refs.formData.validate(valid => {
					if(valid){
						xtsz.updatePwd(that.formData).then(res => {
							if(res.code == 200){
								Message({
									type:'success',
									message:res.msg
								})
								that.formData = {
									oldpword: '',
									password: '',
									flag:this.$store.state.user.userinfo.flag,
									user_id:this.$store.state.user.userinfo.id,
									newPwd:""
								};
								that.resetForm();
							}
						})
					}else{
						
					}
				})
			},
			// 上传封面图成功
			success(res, file) {
				if(res.code == 200){
					that.imgLogo = res.data.src
				}else{
					Message.error("上传失败，请检查文件或网络连接")
				}
			},
			// 清除表单
			resetForm(){
				that.formData = {
					oldpword: '',
					password: '',
					flag:this.$store.state.user.userinfo.flag,
					user_id:this.$store.state.user.userinfo.user_id,
					newPwd:""
				};
				that.$refs.formData.resetFields();
			},
			setlogo(){
				// 设置logo
				this.$store.dispatch('SET_LOGO',{
					dwid:that.dwid,
					logo:that.imgLogo
				})
			},
		},
		created() {
			that = this;
			this.imgLogo = that.logos;
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.datass{
		display: flex;
		justify-content: space-between;
		align-content: flex-start;
		.selectdata{
			padding: 0 30px;
			width: 50%;
			margin:0 auto;
			.titles{
				width: 100%;
				line-height: 50px;
				color: #333;
				font-weight: bold;
				font-size: 14px;
				text-align: left;
				margin-bottom: 30px;
				border-bottom: 1px solid #ededed;
			}
			.logos{
				border: 1px solid #ededed;
				padding: 10px;
				width: 300px;
				height: 100px;
				margin-bottom: 10px;
				img{
					width:100%;
					height: 100%;
					object-fit: scale-down;
				}
			}
		}
		.selectdata:nth-child(1){
			border-right: 1px solid #ededed;
		}
	}
</style>

